//
//
//
//
//
//
//
//
//
//

export default {
  name: 'AsyncSubmenu',
  props: {
    routerInfo: {
      default: function _default() {
        return null;
      },
      type: Object
    }
  }
};